import { Col, Notification, Row, Title } from '@app/components'
import { DynamicList } from '@app/generic-collections'
import { errorHandler } from '@app/services'
import { PlaidWidget } from 'collections/plaid'
import { useEffect, useState } from 'react'

import { BankIcon } from '~public'

export const PaymentMethodList = () => {
  const [paymentMethods] = useState([])
  //   const { user } = useSelector((state: IStore) => state)

  useEffect(() => {
    fetchPaymentMethods()
  }, [])

  const fetchPaymentMethods = async () => {
    try {
      // TODO: re-implement this
    } catch (error) {
      Notification({ message: error.message, type: 'error' })
      errorHandler.report`Failed to fetch payment methods: ${error}`
    }
  }

  const generateMethodList = () => {
    return (
      paymentMethods?.map((item) => {
        return {
          id: item?.attributes['bank-account-type'],
          title: item?.attributes['bank-account-type'] + item?.attributes['last-4'],
          icon: <BankIcon />,
          description: item?.attributes['routing-number'],
          val: item?.id,
        }
      }) || []
    )
  }

  const header = (
    <Row justify={'space-between'}>
      <Col>
        <Title level={4}>Payment Methods</Title>
      </Col>
      <Col>
        <PlaidWidget button={{ title: 'Add', type: 'link' }} refresh={fetchPaymentMethods} />
      </Col>
    </Row>
  )

  return <DynamicList listData={generateMethodList()} header={header} border="true" radioList={false} />
}
